import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { GetUserUIThemeConfiguration } from '../../Models/Models/Session/GetUserUIThemeConfiguration';

declare var IS_RUNNING_IN_APP_POOL;

export class GetUserUIThemeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<GetUserUIThemeConfiguration, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/GetUserUITheme/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<GetUserUIThemeConfiguration, any>(url, data);
  }
  public put(isLightMode: boolean): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/GetUserUITheme/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { isLightMode: isLightMode }

    return AjaxWrapper.put<string, any>(url, data);
  }
}

